import {
  // COMMON
  Page404LayoutComponent,
} from '@net7/boilerplate-common';

// MURUCA
import {
  MrHomeLayoutComponent,
  MrSearchLayoutComponent,
  MrStaticLayoutComponent,
  MrResourceLayoutComponent,
  MrAdvancedSearchLayoutComponent,
  MrAdvancedResultsLayoutComponent,
  LocaleDependenciesGuard,
} from '@net7/boilerplate-muruca';

type RouteConfig = {
  component?: any;
  paths: {
    [locale: string]: string;
  };
  data?: any;
  isRedirect?: boolean;
};

const NOT_FOUND_PATH = 'page-404';
const config: {
  [layoutID: string]: RouteConfig;
} = {

  // OPERE
  records: {
    paths: { it: 'search', en: 'en/search' },
    component: MrSearchLayoutComponent,
    data: { configId: 'search-records' },
  },
  work: {
    paths: { 
      it: 'record/:id/:slug', 
      en: 'en/record/:id/:slug' 
    },
    component: MrResourceLayoutComponent,
    data: { configId: 'resource-record' },
  },
  bibliograficos: {
    paths: { 
      it: 'record/:id/:slug/bibliograficos', 
      en: 'en/record/:id/:slug/bibliograficos' 
    },
    component: MrResourceLayoutComponent,
    data: { configId: 'resource-record-bibliograficos' },
  },
  fecha: {
    paths: { 
      it: 'record/:id/:slug/fecha', 
      en: 'en/record/:id/:slug/fecha' 
    },
    component: MrResourceLayoutComponent,
    data: { configId: 'resource-record-fecha' },
  },
  personajes: {
    paths: { 
      it: 'record/:id/:slug/personajes', 
      en: 'en/record/:id/:slug/personajes' 
    },
    component: MrResourceLayoutComponent,
    data: { configId: 'resource-record-personajes' },
  },
  genero: {
    paths: { 
      it: 'record/:id/:slug/genero', 
      en: 'en/record/:id/:slug/genero' 
    },
    component: MrResourceLayoutComponent,
    data: { configId: 'resource-record-genero' },
  },

  // RICERCA AVANZATA
  search: {
    paths: { it: 'busqueda-avanzada', en: 'en/research' },
    component: MrAdvancedSearchLayoutComponent,
    data: { configId: 'advanced-search' },
  },
  search_results: {
    paths: { it: 'risultati', en: 'en/results' },
    component: MrAdvancedResultsLayoutComponent,
    data: { configId: 'advanced-results' },
  },

  // HOME
  home: {
    component: MrHomeLayoutComponent,
    paths: { it: '', en: 'en/' },
    data: { configId: 'home' },
  },
  homeRedirect: { paths: { en: 'en' }, isRedirect: true },

  // PAGE 404
  page404: {
    paths: { it: NOT_FOUND_PATH, en: `en/${NOT_FOUND_PATH}` },
    component: Page404LayoutComponent,
    data: { id: 'page-404' },
  },

  // PAGINA STATICA
  page: {
    component: MrStaticLayoutComponent,
    paths: {
      it: ':slug',
      en: 'en/:slug',
    },
    data: { configId: 'page' },
  },
};

const APP_ROUTES: any = [
  {
    path: 'home',
    redirectTo: '',
    pathMatch: 'full',
  },
  {
    path: 'record/:id/:slug',
    redirectTo: 'record/:id/obra/bibliograficos',
    pathMatch: 'full',
  },
  { // Redirect per il vecchio Calderon
    path: 'record/:id',
    redirectTo: 'record/:id/obra/bibliograficos',
    pathMatch: 'full',
  },
];

/**
 * Generate angular routes from config
 */
Object.keys(config).forEach((routeId) => {
  const { component, data, paths, isRedirect } = config[routeId];
  Object.entries(paths).forEach(([locale, path]) => {
    // path to component
    if (component) {
      APP_ROUTES.push({
        path,
        component,
        data: { ...data, routeId, locale },
        canActivate: [LocaleDependenciesGuard],
      });
    }
    // catch route
    if (isRedirect) {
      APP_ROUTES.push({ path, redirectTo: `${path}/` });
    }
  });
});

export { APP_ROUTES };